import React from 'react';
import {
  Paper, Typography, Chip, Stack, Grid, Avatar
} from '@mui/material';
import AuthService from '../Auth/AuthService';

const SchoolCardView = ({ school }) => (
  <Paper
    elevation={3}
    sx={{
      p: 3,
      borderLeft: '8px solid #3f51b5',
      mb: 3,
      backgroundColor: '#fafafa',
      borderRadius: 3
    }}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
      <Stack direction="row" spacing={2} alignItems="center">
        {school.logoUrl && (
          <Avatar
            alt="School Logo"
            src={AuthService.DOC_URL + school.logoUrl}
            sx={{ width: 56, height: 56 }}
          />
        )}
        <Typography variant="h5" fontWeight="bold" color='#3f2d01'>
          {school.schoolName || 'Logo'}
        </Typography>
      </Stack>
      <Chip
        label={school.isActive ? 'Active' : 'Inactive'}
        color={school.isActive ? 'success' : 'default'}
        size="medium"
      />
    </Stack>

    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Typography><strong>Dise Code:</strong> {school.diseCode}</Typography>
        <Typography><strong>Registration No:</strong> {school.registrationNumber}</Typography>
        <Typography><strong>Principal:</strong> {school.principalName}</Typography>
        <Typography><strong>Email:</strong> {school.contactEmail}</Typography>
        <Typography><strong>Phone:</strong> {school.contactPhone}</Typography>
        <Typography><strong>City:</strong> {school?.addressDTO?.city}</Typography>
        <Typography><strong>State:</strong> {school?.addressDTO?.state}</Typography>
        <Typography><strong>Country:</strong> {school?.addressDTO?.country}</Typography>
        <Typography><strong>Pincode:</strong> {school?.addressDTO?.pincode}</Typography>
        <Typography><strong>Latitude:</strong> {school?.addressDTO?.latitude}</Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Typography><strong>Board:</strong> {school.boardAffiliation}</Typography>
        <Typography><strong>Established:</strong> {school.establishedYear}</Typography>
        <Typography><strong>School Type:</strong> {school.schoolType}</Typography>
        <Typography><strong>Medium:</strong> {school.mediumOfInstruction}</Typography>
        <Typography><strong>Total Students:</strong> {school.totalStudents}</Typography>
        <Typography><strong>Total Teachers:</strong> {school.totalTeachers}</Typography>
        <Typography><strong>Total Classes:</strong> {school.totalClasses}</Typography>
        <Typography>
          <strong>Website:</strong>{' '}
          <a href={school.websiteUrl} target="_blank" rel="noopener noreferrer">
            {school.websiteUrl}
          </a>
        </Typography>
        <Typography><strong>Address:</strong> {school.addressDTO?.addressLine1}</Typography>
        <Typography><strong>Longitude:</strong> {school?.addressDTO?.longitude}</Typography>
      </Grid>
    </Grid>
  </Paper>
);

export default SchoolCardView;
